// Branded UUIDv4 ID types — one per entity. The brand exists at the type
// level only and erases at runtime. The point is to make it impossible to
// accidentally pass an AssetId where a ReportId is expected.
//
// Why UUIDs and not serial integers (v2 style):
//   - Offline-first frontend (v3.md) needs to mint IDs without a network
//     round trip. Server-assigned serials force a rename-after-sync dance.
//   - Microservices on cheap infra means cross-service references are common
//     and shouldn't expose row counts.
//
// IDs are validated against the canonical `uuidSchema` from @bitacorapro/shared,
// which enforces RFC 4122 v4 specifically (not v1 / v7 / arbitrary UUID).
import { uuidSchema } from "@bitacorapro/shared";
// Mint via the WHATWG Web Crypto global, not `node:crypto`. This package is
// isomorphic: it is bundled into the browser PWA (apps/web-svelte) and the
// dashboard (apps/web-dashboard) as well as the Node services. `globalThis.crypto`
// exposes `randomUUID()` in Node 22 (global since Node 19) and in every modern
// browser over a secure context, producing the same RFC 4122 v4 strings as
// `node:crypto.randomUUID()` — so no `node:` builtin reaches the browser bundle.
// See ADR-0048.
const randomUUID = () => globalThis.crypto.randomUUID();
function brandedIdSchema() {
    return uuidSchema;
}
export const organizationIdSchema = brandedIdSchema();
export const assetGroupIdSchema = brandedIdSchema();
export const assetIdSchema = brandedIdSchema();
export const reportIdSchema = brandedIdSchema();
export const findingIdSchema = brandedIdSchema();
export const evidenceIdSchema = brandedIdSchema();
export const areaCaptureIdSchema = brandedIdSchema();
export const reportTokenIdSchema = brandedIdSchema();
export const userIdSchema = brandedIdSchema();
export const checklistTemplateIdSchema = brandedIdSchema();
export const maintenanceItemIdSchema = brandedIdSchema();
export const newOrganizationId = () => randomUUID();
export const newAssetGroupId = () => randomUUID();
export const newAssetId = () => randomUUID();
export const newReportId = () => randomUUID();
export const newFindingId = () => randomUUID();
export const newEvidenceId = () => randomUUID();
export const newAreaCaptureId = () => randomUUID();
export const newReportTokenId = () => randomUUID();
export const newUserId = () => randomUUID();
export const newChecklistTemplateId = () => randomUUID();
//# sourceMappingURL=ids.js.map